module.exports = __webpack_public_path__ + "static/media/CERTIFICATE-LIGA-ANAK-PINTAR-1.d8457592.png";